import { useGetUserChallengeRanks } from '#hooks/use-get-user-challenge-ranks.hook.ts';
import { useGetTeamChallengeRanks } from '#pages/challenge-landing-page/hooks/use-get-team-challenge-ranks.hook.ts';

export const LEADERBOARD_VIEWS = ['individual', 'team'] as const;
export type LeaderboardView = (typeof LEADERBOARD_VIEWS)[number];

export const useGetLeaderboardData = (
  leaderboardView: LeaderboardView,
  teamsEnabled: boolean,
) => {
  const individualLeaderboardData = useGetUserChallengeRanks();
  const teamLeaderboardData = useGetTeamChallengeRanks(teamsEnabled);

  if (leaderboardView === 'individual') {
    return individualLeaderboardData;
  }
  return teamLeaderboardData;
};
